import React from 'react'
import { SubHeroText } from '../Home/Styles'
function Contact() {
  return (
    <div class="container-flex contact-body flex align-items-center justify-content-center">
        <div class="row flex contact-card align-items-center justify-content-center">
            <div class="col-9 my-5 bg-white p-5 md:p-2 opacity-90 shadow rounded-sm">
                <SubHeroText>CONTACT</SubHeroText>
                <div class="input-div mt-5 w-full">
                    <div class="h2">Email</div>
                    <input required='true'  pattern='/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/'
 class="custom-contact-input " placeholder='Enter email' type='email' />
                </div>
                <div class="input-div mt-5 w-full">
                    <div class="h2">Message</div>
                    <textarea class="custom-contact-input " placeholder='Enter message' type='text' />
                </div>
                <div class=" mt-5 w-full flex flex-row-reverse">
                    <button class="contact-submit">Submit</button>    
                </div>
                
            </div>
        </div>
    </div>
  )
}

export default Contact